import React from 'react';
import BaseType from './BaseType';

const CompanyAdded = ({ items, children, count, time, onClick, expanded }) => {
  return (
    <BaseType
      logos={items.map((item) => {
        return item?.metadata?.known_org?.logo_url;
      })}
      mainText={`${count} companies`}
      tagText='Added to campaigns'
      tagType='neutral'
      time={time}
      onClick={onClick}
      expanded={expanded}
    >
      {children}
    </BaseType>
  );
};

export default CompanyAdded;
